import { render, staticRenderFns } from "./detailAffiliateRelation.vue?vue&type=template&id=5e6d9d8f&scoped=true"
import script from "./detailAffiliateRelation.vue?vue&type=script&lang=js"
export * from "./detailAffiliateRelation.vue?vue&type=script&lang=js"
import style0 from "./detailAffiliateRelation.vue?vue&type=style&index=0&id=5e6d9d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6d9d8f",
  null
  
)

export default component.exports